import { FC, useState } from 'react';
import React from 'react';
import { Progressbar } from '../Progressbar';
import { AnswerData } from '../../../api/interfaces';
import styles from './TestForm.module.scss';
import { Checkbox } from '../Checkbox';
import { Heading } from '../Heading';
import { Button } from '../Button';
import { TestFormStrings } from 'utils/strings';
import { Texts } from '../Texts';
import { Decorator } from '../Decorator';

interface TestFormProps {
  id: number;
  position: number;
  question: string;
  answers: AnswerData[];
  testLength: number;
  questionsRoute: (selectedAnswer: string) => void;
}

export const TestForm: FC<TestFormProps> = ({
  id,
  position,
  testLength,
  question,
  answers,
  questionsRoute,
}) => {
  const [selected, setSelected] = useState<string | null>(null);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(event.target.id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (selected) {
      questionsRoute(selected);
    }
    setSelected(null);
  };

  return (
    <section className={styles.test_form}>
      <form className={styles.form_body} onSubmit={handleSubmit}>
        <div className={styles.form_fieldset}>
          <legend className={styles.form_legend} aria-live="assertive">
            <Decorator />
            <Texts className={styles.question_position}>
              {`Pytanie ${position} z ${testLength}`}
            </Texts>
            <Heading type="h2">{question}</Heading>
          </legend>
          <Progressbar progress={position / testLength} />
          <div className={styles.form_checkbox_align}>
            {answers.map((answer) => (
              <Checkbox
                className={styles.form_checkbox}
                key={`question_${id}_${answer.id}`}
                id={answer.id}
                type={'radio'}
                name={`question_${position}`}
                label={answer.answer}
                onChange={onChange}
              />
            ))}
          </div>
        </div>
        <Button
          className={styles.nextPageNavigation}
          buttonType="submit"
          disabled={!selected}
        >
          {position === testLength
            ? TestFormStrings().continue
            : TestFormStrings().nextQuestion}
        </Button>
      </form>
    </section>
  );
};
